import React, { memo, useMemo } from "react";
import { debounce, sumBy } from "lodash";
import styled from "styled-components";
import { shorten } from "@backpacker/number";
import Legend from "@charty/legend";
import Tooltip from "@charty/tooltip/histogram";
import { getMetricLabel } from "@linkfluence/i18n";
import { Metric } from "@linkfluence/models/metric";
import { LegendProps } from "../model";

const StyledLegend = styled(Legend)`
  margin-bottom: 12px;
  overflow-y: hidden;
`;

const StackedBarChartLegend = ({
  series,
  setHovered,
  locale,
  onClickLegend,
  total,
  disableAnimation,
  displayVolumes,
  metric,
}: LegendProps & { metric?: Metric }) => {
  const _total = useMemo(() => {
    if (total) return total;
    return sumBy(series, "count");
  }, [series, total]);

  return (
    <StyledLegend
      withOrder
      items={series}
      disableAnimation={disableAnimation}
      displayVolumes={displayVolumes}
      setHovered={debounce(setHovered, 50)}
      align="left"
      locale={locale}
      onClickSerie={onClickLegend}
      tooltip={(serie) => (
        <Tooltip
          count={serie.count}
          label={serie.label}
          color={serie.color}
          locale={locale}
          total={_total}
          content={
            <>
              {shorten(locale, serie.count)}{" "}
              {getMetricLabel(locale, metric).toLowerCase()}
            </>
          }
        />
      )}
      magicWandCursor
    />
  );
};

export default memo(StackedBarChartLegend);
